// Vrai uniquement pendant le pré-rendu au build (scripts/prerender.mjs fixe
// un user-agent spécifique). Sert à figer les composants sur leur état initial
// pour que l'hydratation côté client corresponde exactement au HTML servi.
export const isPrerender = () =>
  typeof navigator !== 'undefined' && / Prerender\/1/.test(navigator.userAgent);
